function katakana2hiragana(str) {
	return str.replace(/[\u30a1-\u30f6]/g, function(match) {
		var chr = match.charCodeAt(0) - 0x60;
		return String.fromCharCode(chr);
	});
}

Vue.component("search-app", {
	template: `
	<div>
		<index-view
			:cond="cond"
			@searchByArea="searchByArea"
			@updateResultCount="updateResultCount($event)"
			@showResultsMap="showResultsMap($event)"
			@showResultsList="showResultsList($event)"
		></index-view>
		<result-popup v-if="store.resultMode"
			:cond="cond"
			@hideResults="hideResults"
			@toggleResultMode="toggleResultMode"
			@setShop="setShop"
		></result-popup>
		<shop-popup v-if="store.currentShop" :shop="store.currentShop"
			@close="setShop(null, true)"></shop-popup>
	</div>
	`,
	data() {
		return {
			store,
			cond: {}
		};
	},
	mounted() {
		// History state の設定
		window.addEventListener("popstate", event => {
			const {state} = event;
			if (state) {
				store.resultMode = state.resultMode ? state.resultMode : null;
				store.currentShop = state.shop ? state.shop : null;
				this.initSlideshow();
			} else {
				store.resultMode = null;
				store.currentShop = null;
			}
		}, false);

		if (store.pushStateSupport) {
			history.replaceState({shop: null}, store.pageTitle);
		}

		// リンク設定（時間があれば Vue で書き直す）
		window.addEventListener("shopTrigger", event => {
			if (!event.shopId) {
				return;
			}
			this.setShopById(event.shopId);
		}, false);
	},
	watch: {
		["store.resultMode"]() {
			ModalManager.setOpen(this.store.resultMode || this.store.currentShop);
		},
		["store.currentShop"]() {
			ModalManager.setOpen(this.store.resultMode || this.store.currentShop);
		},
	},
	methods: {

		updateResultCount(cond) {
			const {store} = this;

			this.cond = cond

			if (store.baths === null) {
				return;
			}

			if (this.cond === null) {
				store.showResult = false;
				store.resultCount = 0;
				return;
			}

			this.search(this.cond, results => {
				store.showResult = true;
				store.resultCount = results.length;
			});
		},

		searchByArea(area) {
			const {store} = this;

			if (store.baths === null) {
				return;
			}

			this.cond = {area};
			this.showResultsMap(this.cond);
		},

		search(cond, callback) {
			const {baths, facilities, bathFeatures} = this.store;

			this.$set(this, 'cond', cond)

			const results = baths.filter(bath => {

				// 地域
				if (!this.matchArea(bath, cond.area)) {
					return false;
				}

				// 駐車場
				if (cond.has_parking && bath.num_parking < 0) {
					return false;
				}

				// その他
				const facilityUnmatch = facilities.some(item => cond[item.name] && !bath[item.name]);
				const featureUnmatch = bathFeatures.some(item => cond[item.name] && !bath[item.name]);
				if (facilityUnmatch || featureUnmatch) {
					return false;
				}

				// キーワード
				if (!this.matchKeyword(bath, cond.q)) {
					return false;
				}

				return true;
			});

			if (cond.area === "現在地") {
				// setTimeout(function() {
				// 	store.position = {lat: 36.591515, lng: 136.633349};
				// 	callback(results);
				// }, 3000);
				// return;
				navigator.geolocation.getCurrentPosition((position) => {
					store.position = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
					callback(results);
				}, () => {
					alert("位置情報の取得に失敗しました");
					store.position = "auto";
					callback({});
				}, {
					enableHighAccuracy: true,
				});
				return;
			}

			store.position = "auto";
			callback(results);
		},

		matchArea(bath, area) {
			switch (area) {
			case "現在地":
				break;
			case "能登地域":
				if (!/七尾市|輪島市|珠洲市|羽咋市|かほく市|羽咋郡|鹿島郡|鳳珠郡|河北郡/.test(bath.city)) {
					return false;
				}
				break;
			case "金沢市内":
				if (!/金沢市/.test(bath.city)) {
					return false;
				}
				break;
			case "加賀地域":
				if (!/小松市|加賀市|白山市|野々市市|能美市|能美郡/.test(bath.city)) {
					return false;
				}
				break;
			default:
				break;
			}
			return true;
		},

		matchKeyword(bath, keyword) {
			if (keyword == null) {
				return true;
			}

			let qs = String(keyword).trim().toLowerCase();
			if (qs === "") {
				return true;
			}
			qs = katakana2hiragana(qs);

			const heystack = katakana2hiragana([
				bath.name, " ",
				bath.kana, " ",
				bath.city, bath.address, bath.address2, " ",
				bath.description
			].join("").toLowerCase());

			const unmatch = qs.split(/\s+/).some(q => heystack.indexOf(q) === -1);
			return !unmatch;
		},

		toggleResultMode() {
			const {store} = this;
			const mode = (store.resultMode === "list") ? "map" : "list";
			this.setResultMode(mode);
		},

		showResultsMap(cond) {
			const {store} = this;
			store.results = false;
			this.setResultMode("map");
			this.search(cond, results => {
				store.results = results;
			});
		},

		showResultsList(cond) {
			const {store} = this;
			store.results = false;
			this.setResultMode("list");
			this.search(cond, results => {
				store.results = results;
			});
		},

		setResultMode(mode) {
			const {store} = this;
			var obj;

			store.resultMode = mode;

			if (store.pushStateSupport) {
				obj = {
					resultMode: mode,
					shop: null,
				};
				if (history.state && history.state.resultMode) {
					history.replaceState(obj, store.pageTitle, "/search/");
				} else {
					history.pushState(obj, store.pageTitle, "/search/");
				}
			}
		},

		hideResults() {
			if (history.state && history.state.resultMode) {
				history.back();
				return;
			}

			this.store.resultMode = null;
		},

		setShop(shop, isBack) {
			const {store} = this;

			if (isBack) {
				// 「戻る」ボタンを押したとき、 history.state オブジェクトが存在するかどうかで
				// 履歴を戻るか決定する
				if (history.state) {
					history.back();
					return;
				}
			}

			store.currentShop = shop;
			this.initSlideshow();

			if (store.pushStateSupport && shop) {
				const obj = {
					resultMode: store.resultMode,
					shop: shop,
				};
				history.pushState(obj, shop.name, "/bath/" + shop.id + "/");
			}
		},

		setShopById(shopId) {
			shopId = parseInt(shopId, 10);
			const shops = this.store.baths.filter(bath => bath.id === shopId);
			if (shops.length === 1) {
				this.setShop(shops[0]);
			}
		},

		initSlideshow() {
			setTimeout(() => {
				[].forEach.call(document.querySelectorAll(".slide-list"), (wrapE) => {
					new BS.Slideshow(wrapE, {
						interval: 6000,
						hoverToStop: true
					});
				});
			}, 50);
		},

	}
});